import React, { useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import eventEmitter from "../shared/events";

import PreshipmentIndex from "./index";
import PreshipmentUpcIndex from "./upc";
import SearchUpcIndex from "./search";
import UploadContentIndex from "./upload-content";
import { useAlert } from "hooks/useAlert";
import { SettingsContext } from "contexts/settings";

const EVENT_NAVIGATION = "NAVIGATION_EVENT";

const PreshipmentRoutes = (props) => {
    const push = useNavigate();
    const { toggleAlert } = useAlert();
    const { settings } = useContext(SettingsContext);

    const navigate = (path) => {
        const pathname = window.location.pathname;
        const currentUrl = pathname.endsWith("/") ? pathname.substring(0, pathname.length - 1) : pathname;

        if (!path || path.length === 0) {
            const regex = new RegExp("/[^/]*$");
            push(currentUrl.replace(regex, "/"));

            return;
        }

        push(`${currentUrl}/${path}`);
    };

    useEffect(() => {
        if (settings.globalNotifications.messages.length) {
            toggleAlert();
        }
    }, [settings.globalNotifications.messages.length]);

    useEffect(() => {
        eventEmitter.on(EVENT_NAVIGATION, navigate);

        return () => eventEmitter.removeListener(EVENT_NAVIGATION, navigate);
    }, []);

    return (
        <Routes>
            <Route exact path="/" element={<PreshipmentIndex />} />
            <Route path="upc/:id" element={<PreshipmentUpcIndex />} />
            <Route path="search-upc" element={<SearchUpcIndex />} />
            <Route path="upload-content"
                   element={<UploadContentIndex />} />
        </Routes>
    );
};

export default PreshipmentRoutes;
